import React, { Component } from 'react';
import { connect } from "react-redux";
import StackedBarChart from '../../components/bar-charts/stackedBarChart';
import CustomSelect from "../../components/common/select/Select";
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DATA from '../../assets/data';
import { compare } from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class ActivationMetrics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedYear: [],
            selectedMonth: [],
            selectedPromoType: [],
            data: [],
            popUp: false,
            months: DATA.QUARTER_MONTHS,
            years: DATA.YEARSPreVsPostOpso,
            promotionTypes: DATA.PROMO_TYPES,
            filePopUp: false
        };
    }

    componentDidMount() {

        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        let currentYearIndex = this.state.years.findIndex(year => year.value === currentYear);

        this.handleYearCheckonMounting(currentYearIndex - 1)          // Marking Year one less than current year check on component mounting
        this.handleYearCheckonMounting(currentYearIndex)          // Marking current Year check on component mounting

        let arr = []
        if (this.props.categories) {
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                setTimeout(() => {
                    this.handleSubmit()
                }, 700)
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.categories !== this.props.categories) {
            let arr = []
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                this.handleSubmit();
            })
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.activationMetrics) {
            if (nextProps.activationMetrics) {
                this.propsReceived(nextProps.activationMetrics);
            }
        }
    }

    getUnique = (array) => {

        var categoryNames = []
        var popUip = '';

        const uniqueArray = Array.from(new Set(array.map(a => a.MapCategory)))
            .map(MapCategory => {
                return array.find(a => a.MapCategory === MapCategory)
            })

        uniqueArray.forEach((element, ind) => {
            if (element.MapCategory === 'UiP') {
                popUip = uniqueArray.splice(ind, 1)
            } else {
                categoryNames.push(element.MapCategory)
            }
        });

        if (popUip) {
            categoryNames.push(popUip[0].MapCategory)
        }

        // console.log(popUip)
        // console.log(uniqueArray)
        // console.log(categoryNames)
        return categoryNames
    }


    propsReceived = (value) => {
        let arr = []
        if (value) {
            // let filterValue = this.props.categories
            //     .filter(item => {
            //         return !this.state.selectedCategory
            //             ? void 0
            //             : this.state.selectedCategory.includes(item.guid);
            //     })
            //     console.log(filterValue)

            var uniqueNames = this.getUnique(value); // Getting all categories name only once for filtration

            //Creating piars of each category
            uniqueNames.forEach(item => {
                let filterCat = value.filter(elm => {       // eslint-disable-line
                    if (item === elm.MapCategory) {
                        return elm
                    }
                })

                // console.log(uniqueNames);
                // console.log(filterCat)
                // API value conversion for graph mapping
                if (this.state.selectedYear.length === 1 && filterCat[0]?.MapCategory) {       // For Single Year
                    arr.push({
                        name: filterCat[0]?.MapCategory ? filterCat[0]?.MapCategory : '', dod1: filterCat[0]?.Dod ? filterCat[0]?.Dod.toFixed(2) : 0,
                        vod1: filterCat[0]?.Vod ? filterCat[0]?.Vod.toFixed(2) : 0,
                        PromotionIntensity1: filterCat[0]?.PromotionIntensity ? filterCat[0]?.PromotionIntensity.toFixed(2) : 0,
                        year: (filterCat[0]?.Year ? filterCat[0]?.Year : '')
                    })
                }
                else if (this.state.selectedYear.length === 2 && filterCat[0]?.MapCategory) {      // For Two Years
                    arr.push({
                        name: filterCat[0]?.MapCategory ? filterCat[0]?.MapCategory : '', dod1: filterCat[0]?.Dod ? filterCat[0]?.Dod.toFixed(2) : 0,
                        dod2: filterCat[1]?.Dod ? filterCat[1]?.Dod.toFixed(2) : 0, vod1: filterCat[0]?.Vod ? filterCat[0]?.Vod.toFixed(2) : 0,
                        vod2: filterCat[1]?.Vod ? filterCat[1]?.Vod.toFixed(2) : 0,
                        PromotionIntensity1: filterCat[0]?.PromotionIntensity ? filterCat[0]?.PromotionIntensity.toFixed(2) : 0,
                        PromotionIntensity2: filterCat[1]?.PromotionIntensity ? filterCat[1]?.PromotionIntensity.toFixed(2) : 0,
                        year: (filterCat[0]?.Year ? filterCat[0]?.Year : '') + "" + (filterCat[1]?.Year ? '-' + filterCat[1]?.Year : '')
                    })
                }
                //         else if (this.state.selectedYear.length === 3 && filterCat[0] ?.MapCategory) {      // For Three Years
                //             arr.push({
                //                 name: filterCat[0] ?.MapCategory ? filterCat[0] ?.MapCategory : '', dod1: filterCat[0] ?.Dod ? filterCat[0] ?.Dod.toFixed(2) : 0,
                //                 dod2: filterCat[1] ?.Dod ? filterCat[1] ?.Dod.toFixed(2) : 0, dod3: filterCat[2] ?.Dod ? filterCat[2] ?.Dod.toFixed(2) : 0,
                //                 vod1: filterCat[0] ?.Vod ? filterCat[0] ?.Vod.toFixed(2) : 0, vod2: filterCat[1] ?.Vod ? filterCat[1] ?.Vod.toFixed(2) : 0,
                //                 vod3: filterCat[2] ?.Vod ? filterCat[2] ?.Vod.toFixed(2) : 0,
                //                 PromotionIntensity1: filterCat[0] ?.PromotionIntensity ? filterCat[0] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity2: filterCat[1] ?.PromotionIntensity ? filterCat[1] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity3: filterCat[2] ?.PromotionIntensity ? filterCat[2] ?.PromotionIntensity.toFixed(2) : 0,
                //                 year: (filterCat[0] ?.Year ? filterCat[0] ?.Year : '') + "" + (filterCat[1] ?.Year ? '-' + filterCat[1] ?.Year : '')
                //                     + "" + (filterCat[2] ?.Year ? '-' + filterCat[2] ?.Year : '')
                //             })
                //         }
                //         else if (this.state.selectedYear.length === 4 && filterCat[0] ?.MapCategory) {      // For Four Years
                //             arr.push({
                //                 name: filterCat[0] ?.MapCategory ? filterCat[0] ?.MapCategory : '', dod1: filterCat[0] ?.Dod ? filterCat[0] ?.Dod.toFixed(2) : 0,
                //                 dod2: filterCat[1] ?.Dod ? filterCat[1] ?.Dod.toFixed(2) : 0, dod3: filterCat[2] ?.Dod ? filterCat[2] ?.Dod.toFixed(2) : 0,
                //                 dod4: filterCat[3] ?.Dod ? filterCat[3] ?.Dod.toFixed(2) : 0,
                //                 vod1: filterCat[0] ?.Vod ? filterCat[0] ?.Vod.toFixed(2) : 0, vod2: filterCat[1] ?.Vod ? filterCat[1] ?.Vod.toFixed(2) : 0,
                //                 vod3: filterCat[2] ?.Vod ? filterCat[2] ?.Vod.toFixed(2) : 0, vod4: filterCat[3] ?.Vod ? filterCat[3] ?.Vod.toFixed(2) : 0,
                //                 PromotionIntensity1: filterCat[0] ?.PromotionIntensity ? filterCat[0] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity2: filterCat[1] ?.PromotionIntensity ? filterCat[1] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity3: filterCat[2] ?.PromotionIntensity ? filterCat[2] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity4: filterCat[3] ?.PromotionIntensity ? filterCat[3] ?.PromotionIntensity.toFixed(2) : 0,
                //                 year: (filterCat[0] ?.Year ? filterCat[0] ?.Year : '') + "" + (filterCat[1] ?.Year ? '-' + filterCat[1] ?.Year : '')
                //                     + "" + (filterCat[2] ?.Year ? '-' + filterCat[2] ?.Year : '') + "" + (filterCat[3] ?.Year ? '-' + filterCat[3] ?.Year : '')
                //             })
                //         }
                //         else if (this.state.selectedYear.length === 5 && filterCat[0] ?.MapCategory) {      // For Five Years
                //             arr.push({
                //                 name: filterCat[0] ?.MapCategory ? filterCat[0] ?.MapCategory : '', dod1: filterCat[0] ?.Dod ? filterCat[0] ?.Dod.toFixed(2) : 0,
                //                 dod2: filterCat[1] ?.Dod ? filterCat[1] ?.Dod.toFixed(2) : 0, dod3: filterCat[2] ?.Dod ? filterCat[2] ?.Dod.toFixed(2) : 0,
                //                 dod4: filterCat[3] ?.Dod ? filterCat[3] ?.Dod.toFixed(2) : 0, dod5: filterCat[4] ?.Dod ? filterCat[4] ?.Dod.toFixed(2) : 0,
                //                 vod1: filterCat[0] ?.Vod ? filterCat[0] ?.Vod.toFixed(2) : 0, vod2: filterCat[1] ?.Vod ? filterCat[1] ?.Vod.toFixed(2) : 0,
                //                 vod3: filterCat[2] ?.Vod ? filterCat[2] ?.Vod.toFixed(2) : 0, vod4: filterCat[3] ?.Vod ? filterCat[3] ?.Vod.toFixed(2) : 0,
                //                 vod5: filterCat[4] ?.Vod ? filterCat[4] ?.Vod.toFixed(2) : 0,
                //                 PromotionIntensity1: filterCat[0] ?.PromotionIntensity ? filterCat[0] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity2: filterCat[1] ?.PromotionIntensity ? filterCat[1] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity3: filterCat[2] ?.PromotionIntensity ? filterCat[2] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity4: filterCat[3] ?.PromotionIntensity ? filterCat[3] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity5: filterCat[4] ?.PromotionIntensity ? filterCat[4] ?.PromotionIntensity.toFixed(2) : 0,
                //                 year: (filterCat[0] ?.Year ? filterCat[0] ?.Year : '') + "" + (filterCat[1] ?.Year ? '-' + filterCat[1] ?.Year : '')
                //                     + "" + (filterCat[2] ?.Year ? '-' + filterCat[2] ?.Year : '') + "" + (filterCat[3] ?.Year ? '-' + filterCat[3] ?.Year : '')
                //                     + "" + (filterCat[4] ?.Year ? '-' + filterCat[4] ?.Year : '')
                //             })
                //         }
                //         else if (this.state.selectedYear.length === 6 && filterCat[0] ?.MapCategory) {  // For Six Years
                //             arr.push({
                //                 name: filterCat[0] ?.MapCategory ? filterCat[0] ?.MapCategory : '', dod1: filterCat[0] ?.Dod ? filterCat[0] ?.Dod.toFixed(2) : 0,
                //                 dod2: filterCat[1] ?.Dod ? filterCat[1] ?.Dod.toFixed(2) : 0, dod3: filterCat[2] ?.Dod ? filterCat[2] ?.Dod.toFixed(2) : 0,
                //                 dod4: filterCat[3] ?.Dod ? filterCat[3] ?.Dod.toFixed(2) : 0, dod5: filterCat[4] ?.Dod ? filterCat[4] ?.Dod.toFixed(2) : 0,
                //                 dod6: filterCat[5] ?.Dod ? filterCat[5] ?.Dod.toFixed(2) : 0,
                //                 vod1: filterCat[0] ?.Vod ? filterCat[0] ?.Vod.toFixed(2) : 0, vod2: filterCat[1] ?.Vod ? filterCat[1] ?.Vod.toFixed(2) : 0,
                //                 vod3: filterCat[2] ?.Vod ? filterCat[2] ?.Vod.toFixed(2) : 0, vod4: filterCat[3] ?.Vod ? filterCat[3] ?.Vod.toFixed(2) : 0,
                //                 vod5: filterCat[4] ?.Vod ? filterCat[4] ?.Vod.toFixed(2) : 0, vod6: filterCat[5] ?.Vod ? filterCat[5] ?.Vod.toFixed(2) : 0,
                //                 PromotionIntensity1: filterCat[0] ?.PromotionIntensity ? filterCat[0] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity2: filterCat[1] ?.PromotionIntensity ? filterCat[1] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity3: filterCat[2] ?.PromotionIntensity ? filterCat[2] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity4: filterCat[3] ?.PromotionIntensity ? filterCat[3] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity5: filterCat[4] ?.PromotionIntensity ? filterCat[4] ?.PromotionIntensity.toFixed(2) : 0,
                //                 PromotionIntensity6: filterCat[5] ?.PromotionIntensity ? filterCat[5] ?.PromotionIntensity.toFixed(2) : 0,
                //                 year: (filterCat[0] ?.Year ? filterCat[0] ?.Year : '') + "" + (filterCat[1] ?.Year ? '-' + filterCat[1] ?.Year : '')
                //                     + "" + (filterCat[2] ?.Year ? '-' + filterCat[2] ?.Year : '') + "" + (filterCat[3] ?.Year ? '-' + filterCat[3] ?.Year : '')
                //                     + "" + (filterCat[4] ?.Year ? '-' + filterCat[4] ?.Year : '') + "" + (filterCat[5] ?.Year ? '-' + filterCat[5] ?.Year : '')
                //             })
                //         }
            })
            this.setState({
                data: arr
            })
        }
    }

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedCategory: []
            }, () => {
                this.handleSubmit()
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedCategory: arr }, () => {
                this.handleSubmit()
            });
        }
    };

    handleSubmit = () => {
        if (this.state.selectedCategory.length) {
            if (this.state.selectedYear.length) {
                this.props.getActivationMetrics(
                    this.state.selectedCategory,
                    this.state.selectedYear,
                    this.state.selectedMonth,
                    this.state.selectedPromoType
                );
            }
            else {
                CustomToast('error', 'Year is not selected!')
            }
        } else {
            CustomToast('error', 'Category is not selected!')
        }
    }

    handleMonthCheck = (ind) => {
        let newArray = [...this.state.months]
        newArray[ind] = { ...newArray[ind], checked: !newArray[ind].checked }
        // this.state.months[ind].checked = !this.state.months[ind].checked
        this.setState({
            months: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.months.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedMonth: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })

    }

    handleYearCheck = (ind) => {
        if (this.state.selectedYear.length === 2 && !this.state.years[ind].checked) {
            CustomToast('warning', 'Can not select more than two years')
            return;
        }
        let newArray = [...this.state.years]
        newArray[ind] = { ...newArray[ind], checked: !newArray[ind].checked }
        // this.state.years[ind].checked = !this.state.years[ind].checked
        this.setState({
            years: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    handleYearCheckonMounting = (ind) => {
        // let newArray = [...this.state.promotionTypes]
        // newArray[ind] = {...newArray[ind], checked: !newArray[ind].checked}
        this.state.years[ind].checked = true        // eslint-disable-line
        this.setState({
            years: this.state.years
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                })
            })
    }

    handlePromoTypeCheck = (ind) => {
        let newArray = [...this.state.promotionTypes]
        newArray[ind] = { ...newArray[ind], checked: !newArray[ind].checked }
        // this.state.promotionTypes[ind].checked = !this.state.promotionTypes[ind].checked
        this.setState({
            promotionTypes: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.promotionTypes.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.guid)
                    }
                })
                this.setState({
                    selectedPromoType: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }


    handleActivationMetXlsxDownload = () => {
        if (this.state.selectedCategory.length) {
            if (this.state.selectedYear.length) {
                this.props.downloadActivationMetXlsx(
                    this.state.selectedCategory,
                    this.state.selectedYear,
                    this.state.selectedMonth,
                    this.state.selectedPromoType
                );
            }
            else {
                CustomToast('error', 'Year is not selected!')
            }
        } else {
            CustomToast('error', 'Category is not selected!')
        }
    }

    render() {
        return (
            <div className='activation-metrics-container'>

                <div className='activation-metrics-heading-cta'>

                    <span className='activation-metrics-heading'>Activation Metrics</span>

                    <CustomSelect.MyCustomSelect
                        className='filter-font-size'
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.categories
                                ? !this.props.categories
                                    ? void 0
                                    : this.props.categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.categories
                                ? this.props.categories
                                    .filter(item => {
                                        return !this.state.selectedCategory
                                            ? void 0
                                            : this.state.selectedCategory.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />
                    <div className='cta-container'>
                        <div className='funnel-filter-container'>
                            <img alt='' className='funnel-filter-image' src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ popUp: !this.state.popUp }) }} />
                            {/* Funnel Icon Popup Filter */}
                            {this.state.popUp ?
                                <ClickAwayListener onClickAway={() => { this.setState({ popUp: false }) }}>
                                    <div className='funnel-pop-up'>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Type of Promo</span>

                                            <div className='promo-column'>
                                                {this.state.promotionTypes.map((item, indx) => (
                                                    <span className='column-item' key={indx}>
                                                        <input type='checkbox' className='column-item-input' checked={item.checked}
                                                            onChange={() => this.handlePromoTypeCheck(indx)} />
                                                        <label>{item.Label}</label>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Month</span>
                                            <div className='month-column'>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind <= 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.checked}
                                                                        onChange={() => this.handleMonthCheck(indx)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind > 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.checked}
                                                                        onChange={() => this.handleMonthCheck(indx + 6)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Year</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.years.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='checkbox' className='column-item-input' checked={item.checked}
                                                                onChange={() => this.handleYearCheck(indx)} />
                                                            <label>{item.label}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </ClickAwayListener>
                                :
                                null
                            }
                        </div>
                        <img alt='' className='images-style' src={require('../../assets/images/refreshArrows.svg')} onClick={this.handleSubmit} />
                        <div className="funnel-filter-container">
                            <div style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={() => {
                                    this.setState({ filePopUp: !this.state.filePopUp });
                                }}
                            >
                                <img
                                    className="image-transform"
                                    src={require("../gt/images/dots.png")}
                                    alt=''
                                />
                            </div>

                            {this.state.filePopUp ? (
                                <ClickAwayListener
                                    onClickAway={() => {
                                        this.setState({ filePopUp: false });
                                    }}
                                >
                                    <div
                                        className="funnel-pop-up"
                                        style={{ width: "140px", height: 'auto', flexDirection: 'column' }}
                                    >
                                        {/* <span className="division-cta">
                                            <input type='checkbox' value={this.state.isDivision} onChange={() => this.setState({ isDivision: !this.state.isDivision })} />
                                            <label>Division</label>
                                        </span> */}
                                        <button className='xlsx-download-cta' onClick={this.handleActivationMetXlsxDownload}>Download Excel</button>
                                    </div>
                                </ClickAwayListener>
                            ) : null}
                        </div>
                    </div>

                </div>

                {this.props.isActivationMetricsLoading ?
                    // Loading
                    <div style={{ marginTop: '100px' }}>
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} style={{ width: '60px', height: '60px' }} />
                    </div>
                    :

                    <div className='chart-legend-container'>
                        {/* Graph Component */}
                        <StackedBarChart data={this.state.data ? this.state.data : []} yearsLength={this.state.selectedYear ? this.state.selectedYear.length : ''} />

                        {/* Legends */}
                        <div className='legends-container'>
                            <span className='legend-item'>
                                <span className='lengend-box' style={{ backgroundColor: '#0353a4' }}></span>
                                <span>VOD</span>
                            </span>
                            <span className='legend-item'>
                                <span className='lengend-box' style={{ backgroundColor: '#fca311' }}></span>
                                <span>DOD</span>
                            </span>
                            <span className='legend-item'>
                                <span className='lengend-box' style={{ backgroundColor: '#908079' }}></span>
                                <span>Promotion Intensity</span>
                            </span>
                        </div>
                    </div>}

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activationMetrics: state.PratDashboardReducer.activationMetrics,
        isActivationMetricsLoading: state.PratDashboardReducer.isActivationMetricsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getActivationMetrics: (
            selectedCategory,
            selectedYear,
            selectedMonth,
            selectedPromoType) => {
            return dispatch(PratDashboardMiddleware.getActivationMetrics(
                selectedCategory,
                selectedYear,
                selectedMonth,
                selectedPromoType));
        },
        downloadActivationMetXlsx: (
            selectedCategory,
            selectedYear,
            selectedMonth,
            selectedPromoType) => {
            return dispatch(PratDashboardMiddleware.downloadActivationMetXlsx(
                selectedCategory,
                selectedYear,
                selectedMonth,
                selectedPromoType));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ActivationMetrics);
